export enum QuoteType {
  Expert = 'expert',
  Frame = 'frame',
  Line = 'line',
  Selection = 'selection',
  SelectionLine = 'selectionLine',
}
